(function () {
  var refreshInFlight = null;
  var lastEventAt = 0;
  var loadingMarkup = '<div class="loading-overlay loading-overlay--custom"><div class="loading-overlay__spinner"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></div>';

  function route(path) {
    var root = window.routes && typeof window.routes.root === "string" ? window.routes.root : "";
    return root.replace(/\/$/, "") + path;
  }

  function normalizeCart(detail) {
    if (!detail) return null;
    return detail.cart || detail;
  }

  function propertyValue(properties, name) {
    if (!properties) return null;
    if (Array.isArray(properties)) {
      var match = properties.find(function (property) {
        return property && (property.name === name || property.key === name || property[0] === name);
      });
      return match ? match.value || match[1] : null;
    }
    return properties[name];
  }

  function hasBuilderLine(cart) {
    return Boolean(cart && Array.isArray(cart.items) && cart.items.some(function (item) {
      var properties = item && item.properties ? item.properties : {};
      return Boolean(
        propertyValue(properties, "_pf_builder_version") ||
        propertyValue(properties, "_pf_builder_payload") ||
        propertyValue(properties, "_pf_preview_image")
      );
    }));
  }

  function sideCartWrapper() {
    return document.querySelector("#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper") ||
      document.querySelector("#halo-cart-sidebar .previewCart-wrapper");
  }

  function fetchCartJson() {
    return fetch(route("/cart.js"), {
      headers: { "Accept": "application/json" },
      credentials: "same-origin",
      cache: "no-store"
    }).then(function (response) {
      if (!response.ok) throw new Error("Could not load cart.");
      return response.json();
    });
  }

  function fetchSideCartHtml() {
    return fetch(route("/cart?view=ajax_side_cart"), {
      headers: { "Accept": "text/html" },
      credentials: "same-origin",
      cache: "no-store"
    }).then(function (response) {
      if (!response.ok) throw new Error("Could not load cart drawer.");
      return response.text();
    });
  }

  function showLoading() {
    var wrapper = sideCartWrapper();
    document.body.classList.add("cart-sidebar-show");

    if (!wrapper) return;
    if (!wrapper.querySelector(".loading-overlay")) {
      wrapper.insertAdjacentHTML("afterbegin", loadingMarkup);
    }
    wrapper.classList.add("is-loading");
  }

  function rerunInsertedScripts(wrapper) {
    Array.from(wrapper.getElementsByTagName("script")).forEach(function (oldScript) {
      var newScript = document.createElement("script");
      Array.from(oldScript.attributes).forEach(function (attr) {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function updateCartCount(cart) {
    if (!cart || typeof cart.item_count === "undefined") return;
    document.querySelectorAll("[data-cart-count]").forEach(function (element) {
      element.textContent = cart.item_count;
    });
    document.querySelectorAll("[data-cart-text]").forEach(function (element) {
      element.textContent = cart.item_count === 1 ? "item" : "items";
    });
  }

  function lineSelector(key) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return '[data-line="' + window.CSS.escape(key) + '"]';
    }
    return '[data-line="' + String(key).replace(/"/g, '\\"') + '"]';
  }

  function previewImageForItem(item) {
    var properties = item && item.properties ? item.properties : {};
    return propertyValue(properties, "_pf_preview_image") ||
      propertyValue(properties, "PF Preview Image") ||
      propertyValue(properties, "Preview Image");
  }

  function ensureThumbUrlDebug(row, previewImage) {
    var properties = row.querySelector(".cart-item-properties, .card-properties");
    if (!properties) {
      var content = row.querySelector(".previewCartItem-content, .cart-item-block-right");
      if (!content) return;
      properties = document.createElement("dl");
      properties.className = row.classList.contains("previewCartItem")
        ? "card-properties definitionList cart-item-properties"
        : "cart-item-properties definitionList";
      content.appendChild(properties);
    }

    var debugRow = properties.querySelector("[data-pf-builder-thumb-url]");
    if (!debugRow) {
      debugRow = document.createElement("div");
      debugRow.className = "product-option pf-builder-thumb-url";
      debugRow.setAttribute("data-pf-builder-thumb-url", "");
      debugRow.innerHTML = '<dt class="definitionList-key">Thumb URL:</dt><dd class="definitionList-value"><a target="_blank" rel="noopener"></a></dd>';
      properties.insertBefore(debugRow, properties.firstChild);
    }

    var link = debugRow.querySelector("a");
    if (link) {
      link.href = previewImage;
      link.textContent = previewImage;
    }
  }

  function applyCartPreviewImages(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    cart.items.forEach(function (item) {
      var previewImage = previewImageForItem(item);
      if (!previewImage || !item.key) return;

      document.querySelectorAll(lineSelector(item.key)).forEach(function (row) {
        var imageLink = row.querySelector(".previewCartItem-image, .cart-item-image");
        if (!imageLink) return;

        var image = imageLink.querySelector("img");
        if (!image) {
          image = document.createElement("img");
          image.alt = item.product_title || item.title || "Custom shirt preview";
          image.loading = "lazy";
          imageLink.appendChild(image);
        }

        image.src = previewImage;
        image.removeAttribute("srcset");
        image.classList.add("pf-builder-cart-preview");
        ensureThumbUrlDebug(row, previewImage);
      });
    });
  }

  function syncHaloExtras(wrapper, cart) {
    if (window.halo && typeof window.halo.dispatchChangeForShippingMessage === "function") {
      window.halo.dispatchChangeForShippingMessage();
    }
    if (window.halo && typeof window.halo.productCollectionCartSlider === "function") {
      window.halo.productCollectionCartSlider();
    }
    if (window.halo && typeof window.halo.updateGiftWrapper === "function") {
      window.halo.updateGiftWrapper();
    }
    if (window.halo && typeof window.halo.getProductCardOfferCounts === "function" && window.jQuery) {
      var response = window.jQuery(wrapper);
      var offerCounts = window.halo.getProductCardOfferCounts(response);
      if (typeof window.halo.publishMixMatchOfferCounts === "function") {
        window.halo.publishMixMatchOfferCounts(offerCounts, "pf-armor-builder-cart");
      }
      if (typeof window.halo.updateProductCardOfferBadges === "function") {
        window.halo.updateProductCardOfferBadges(offerCounts);
      }
      if (typeof window.halo.updateProductCardOfferPricing === "function") {
        window.halo.updateProductCardOfferPricing(offerCounts, cart && cart.currency ? cart.currency : "GBP");
      }
    }
  }

  function refreshSideCart(cart) {
    showLoading();

    return fetchSideCartHtml()
      .then(function (html) {
        var wrapper = sideCartWrapper();
        if (!wrapper) return cart;
        wrapper.innerHTML = html;
        rerunInsertedScripts(wrapper);
        updateCartCount(cart);
        applyCartPreviewImages(cart);
        syncHaloExtras(wrapper, cart);
        document.dispatchEvent(new CustomEvent("cart-update", { detail: { cart: cart } }));
        return cart;
      })
      .finally(function () {
        var wrapper = sideCartWrapper();
        if (wrapper) wrapper.classList.remove("is-loading");
      });
  }

  function openHaloSideCart(cart) {
    var cartPromise = fetchCartJson().catch(function () {
      return cart && Array.isArray(cart.items) ? cart : null;
    });

    refreshInFlight = cartPromise
      .then(function (freshCart) {
        if (!hasBuilderLine(freshCart)) return null;
        return refreshSideCart(freshCart);
      })
      .catch(function () {
        updateCartCount(cart);
      })
      .finally(function () {
        refreshInFlight = null;
      });

    return refreshInFlight;
  }

  function handleCartEvent(event) {
    var now = Date.now();
    if (now - lastEventAt < 100) return;
    lastEventAt = now;

    var cart = normalizeCart(event && event.detail);
    if (refreshInFlight) return;
    openHaloSideCart(cart);
  }

  document.addEventListener("cart:updated", handleCartEvent);
  document.addEventListener("pf:armor-builder:cart-added", handleCartEvent);
  window.addEventListener("cart:updated", handleCartEvent);
  window.addEventListener("pf:armor-builder:cart-added", handleCartEvent);

  document.addEventListener("DOMContentLoaded", function () {
    fetchCartJson()
      .then(function (cart) {
        if (hasBuilderLine(cart)) applyCartPreviewImages(cart);
      })
      .catch(function () {});
  });
})();
